import { defineStore, acceptHMRUpdate } from 'pinia'
import { one2OneClassStatus } from '@/constants/codeMap.js'

import {classListOption} from '@/constants/options'
export const useClassListStore = defineStore({
  id: 'classList',
  state: () => ({
    classType: 0, // 班级类型： 0:班课； 1:学习机大组； 2: 学习机小组 3: 个性化
    activeClassStateStatus:'going', // going 进行中/开课中; noStart 未开课/未开始; ended: 已结束/已结课
    // 班课数据
    managerClassListObjects: {
      beginIngClassList: [], 
      notBeginClassList: [], 
      endedClassList: []
    },
    defaultClass: {
      classCode: '',
      schoolId: '',
      groupClassNo: '',
    },
    classList: [],
    // 学习机数据大组
    learnMachineClassListObjects:{
      beginIngClassList: [], 
      notBeginClassList: [], 
      endedClassList: []
    },
    defaultLearnMachineClass:{
      classCode: '',
      schoolId: '',
      groupClassNo: '',
    },
    learnMachineClassList:[],
    // 学习机小组
    learnMachineSmallClassListObjects:{
      beginIngClassList: [], 
      notBeginClassList: [], 
      endedClassList: []
    },
    defaultLearnMachineSmallClass:{
      classCode: '',
      schoolId: '',
      groupClassNo: '',
    },
    learnMachineSmallClassList:[],

    // 一对一数据
    // {classStatus:状态，1-在读，2-结课，3-未开课,studentCount:学员数}
    one2OneClassList:[]

  }),
  getters: {
    classTypeList(){
      let showClassListOption = [];
      if(this.classList.length){
        showClassListOption = showClassListOption.concat(classListOption.filter(item=>item.value == 0))
      }
      if(this.learnMachineSmallClassList.length){
        showClassListOption = showClassListOption.concat(classListOption.filter(item=>item.value == 2))
      }
      if(this.learnMachineClassList.length){
        showClassListOption = showClassListOption.concat(classListOption.filter(item=>item.value == 1))
      }
      if(this.one2OneClassList.length){
        let studentCount = 0;
        this.one2OneClassList.forEach(item=> studentCount += item.studentCount);
        if(studentCount){
          showClassListOption = showClassListOption.concat(classListOption.filter(item=>item.value == 3))
        }
      }
      return showClassListOption 
    }
  },
  actions: {
    changeClassType(type){
      this.classType = type || 0;
    },
    changeActiveClassStateStatus(status){
      this.activeClassStateStatus = status;
    },
    //班课数据
    setManagerClassListObjects(classObj) {
      this.managerClassListObjects = classObj;
    },
    setDefaultClass(defaultClass) {
      if(!defaultClass)return;
      this.defaultClass = defaultClass;
    },
    setClassList(classList) {
      this.classList = classList;
    },
    // 学习机大组数据
    setLearnMachineClassListObjects(classObj) {
      this.learnMachineClassListObjects = classObj;
    },
    setDefaultLearnMachineClass(defaultLearnMachineClass) {
      if(!defaultLearnMachineClass)return;
      this.defaultLearnMachineClass = defaultLearnMachineClass;
    },
    setLearnMachineClassList(learnMachineClassList) {
      this.learnMachineClassList = learnMachineClassList;
    },

    // 学习机小组数据
    setLearnMachineSmallClassListObjects(classObj) {
      this.learnMachineSmallClassListObjects = classObj;
    },
    setDefaultLearnMachineSmallClass(defaultLearnMachineSmallClass) {
      if(!defaultLearnMachineSmallClass)return;
      this.defaultLearnMachineSmallClass = defaultLearnMachineSmallClass;
    },
    setLearnMachineSmallClassList(learnMachineSmallClassList) {
      this.learnMachineSmallClassList = learnMachineSmallClassList;
    },

    // 更新一对一数据
    setOne2OneClassList(list=[]){
      this.one2OneClassList = list.map(item=>{
        return {
          ...item,
          className: one2OneClassStatus[item.classStatus],
          classCode:'121classCode',
          groupClassNo:'121groupClassNo',
          schoolId:'121schoolId',
          groupCode: item.classStatus
        }
      });
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useClassListStore, import.meta.hot))
}
